export const VOICE_CONFIG = {
  SAMPLE_RATE: 24000,
  LEAVE_DELAY_MS: 300,
} as const;
